import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Helmet} from 'react-helmet'

import NavBar from '../components/NavBar';
import HeroVideo from '../components/HeroVideo';

export default class Sponsorship extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | Sponsorship</title>
                </Helmet>
                <NavBar hasHero={true} />
                <HeroVideo video="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/videos%2FThis%20is%20the%20University%20of%20Sydney.mp4?alt=media&token=64152426-5e78-4c8d-8158-d1ba2a612d1a" />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h1>Sponsorship</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h2>University of Sydney</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>
                                Established in 1850 as the first University in Australia, The University of Sydney was founded on the 
                                principle of giving everyone the opportunity to realise their potential through education and still 
                                holds that belief just as strongly today. Currently ranked 4th in the world, and 1st in Australia, 
                                for graduate employability, the University of Sydney is also consistently placed among the top 50 
                                universities in the world. With a reimagined undergraduate curriculum, world-class facilities, 
                                inspirational academics and a vibrant campus life, it is a place where students can attain widely 
                                recognised and respected qualifications. Committed to academic excellence in teaching and research, 
                                the University of Sydney is a leading institution in the Group of Eight which consists of the top eight 
                                research universities in Australia. Additionally, its excellence is renown internationally through 
                                collaborative research and partnerships.  
                            </p>
                            <p>
                                The 72-hectare campus has been recognized as the most beautiful in Australia and top #10 in the world. 
                                You may find the best facilities in the academic world here including state-of-the-art sports stadiums, 
                                world-class learning and teaching hubs, largest academic library system in Southern hemisphere. As the 
                                first university ever established in Australia, USYD has remained its highly ranking, academic excellent 
                                reputation and prestigious status in the world and that is the reason why each student studying here 
                                always feel honoured to be part of something big and well regarded.
                            </p>
                        </Col>
                    </Row>
                    <br />
                    <Row noGutters>
                        <Col lg={true}><iframe title="Industy Partnership" className="youtube-video" src="https://www.youtube-nocookie.com/embed/QU8WMWsDPFA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></Col>
                        <Col lg={true}><iframe title="Bachelor of Engineering" className="youtube-video" src="https://www.youtube-nocookie.com/embed/8L10B1U1xkc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></Col>
                        <Col lg={true}><iframe title="Hydrogrn Powered Drone" className="youtube-video" src="https://www.youtube-nocookie.com/embed/dG9TjBzEN-8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></Col>
                        <Col lg={true}><iframe title="Bachelor of Engineering Chemisty and Biology" className="youtube-video" src="https://www.youtube-nocookie.com/embed/oRei6Ypvxh4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></Col>
                    </Row>
                </Container>
            </div>
        )
    }
}
